module.exports = __webpack_public_path__ + "static/python-morsels-bg-b9c6b1f52d39667d9e98ed4eb824e52e.jpg";